import { useEffect, useRef } from "react";
import { purgeAuthState } from "./purge-auth-state";

/** Endpoint silencieux : purge la session locale (appelé en iframe depuis Suite /auth/logout). */
export function AuthLogoutSyncPage() {
  const handledRef = useRef(false);

  useEffect(() => {
    if (handledRef.current) return;
    handledRef.current = true;
    purgeAuthState();
  }, []);

  return null;
}
